/**
 * AiSparkle1Icon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const AiSparkle1IconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.826 14.976c.03-.135.224-.135.253 0 .36 1.648.803 2.088 2.451 2.45.135.03.135.224 0 .254-1.648.36-2.088.801-2.45 2.45-.03.135-.224.135-.254 0-.36-1.649-.801-2.088-2.45-2.45-.135-.03-.135-.224 0-.253 1.649-.36 2.088-.803 2.45-2.451m10.54-7.587c.071-.321.527-.321.598 0 .855 3.899 1.896 4.94 5.795 5.795.321.07.321.528 0 .598-3.9.855-4.94 1.896-5.795 5.795-.07.322-.527.321-.598 0-.854-3.9-1.896-4.94-5.796-5.795-.32-.07-.32-.528 0-.598 3.9-.855 4.942-1.896 5.796-5.795M6.33 3.172c.051-.23.379-.23.43 0 .613 2.797 1.36 3.545 4.158 4.158.229.051.229.38 0 .43-2.798.613-3.545 1.36-4.158 4.158-.051.229-.379.229-.43 0C5.717 9.12 4.97 8.373 2.172 7.76c-.23-.051-.23-.379 0-.43 2.797-.613 3.545-1.36 4.158-4.158" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const AiSparkle1Icon = makeIcon('AiSparkle1Icon', AiSparkle1IconSvg)
